import { Component, EventEmitter, Input, Output, inject, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video-modal',
  standalone: false,
  templateUrl: './video-modal.component.html',
  styleUrl: './video-modal.component.scss',
})
export class VideoModalComponent {

  @Input() videoUrl: string = '';
  @Input() title: string = '';
  @Input() showVideoModal: boolean = false;
  @Output() closeModal = new EventEmitter<void>();

  safeVideoUrl: SafeResourceUrl | null = null;

  private sanitizer = inject(DomSanitizer);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['videoUrl'] && this.videoUrl) {
      this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
    }
  }

  closeVideoModal() {
    this.showVideoModal = false;
    this.safeVideoUrl = null;
    this.closeModal.emit();
  }
}
